/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOrUpdateBeamAnalysisTaskItemAreaDataDto } from './CreateOrUpdateBeamAnalysisTaskItemAreaDataDto';
import {
    instanceOfCreateOrUpdateBeamAnalysisTaskItemAreaDataDto,
    CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoFromJSON,
    CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoFromJSONTyped,
    CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoToJSON,
} from './CreateOrUpdateBeamAnalysisTaskItemAreaDataDto';

/**
 * @type CreateOrUpdateTaskItemAreaDataDto
 * 
 * @export
 */
export type CreateOrUpdateTaskItemAreaDataDto = { $type?: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.CreateOrUpdateBeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application' } & CreateOrUpdateBeamAnalysisTaskItemAreaDataDto;


export function CreateOrUpdateTaskItemAreaDataDtoFromJSON(json: any): CreateOrUpdateTaskItemAreaDataDto {
    return CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemAreaDataDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.CreateOrUpdateBeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application':
            return Object.assign({}, CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.CreateOrUpdateBeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application' } as const);
        default:
            throw new Error(`No variant of CreateOrUpdateTaskItemAreaDataDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateOrUpdateTaskItemAreaDataDtoToJSON(value?: CreateOrUpdateTaskItemAreaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.CreateOrUpdateBeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application':
            return CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateOrUpdateTaskItemAreaDataDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateOrUpdateTaskItemAreaDataDto interface.
 */
export function instanceOfCreateOrUpdateTaskItemAreaDataDto(value: any): value is CreateOrUpdateTaskItemAreaDataDto {
    if (instanceOfCreateOrUpdateBeamAnalysisTaskItemAreaDataDto(value)) return true;
    return false;
}

